import { CustomTooltip } from '@cian/ui-kit';
import * as React from 'react';
import { InteractiveElementsWrapper } from '../../../InteractiveElementsWrapper';
import { ILabelLayoutProps } from '../../types';

export const LabelLayoutDesktop = React.forwardRef<HTMLDivElement, React.PropsWithChildren<ILabelLayoutProps>>(
  (
    { tooltipContent, tooltipOpened, toggleTooltip, children, onClick, className },
    ref: React.RefObject<HTMLDivElement | null>,
  ) => {
    return (
      <InteractiveElementsWrapper
        onMouseEnter={toggleTooltip}
        onMouseLeave={toggleTooltip}
        onClick={onClick}
        className={className}
      >
        {children}
        <CustomTooltip open={tooltipOpened} content={tooltipContent} anchorRef={ref} placement="bottom-start" />
      </InteractiveElementsWrapper>
    );
  },
);

LabelLayoutDesktop.displayName = 'LabelLayoutDesktop';
